<div  style='text-align: center'>
    <p>Waiting for authorization…</p>   
</div>